import { ZirpApiClient } from "@zirp/client";

export const useApi = () => {
  const { $api } = useNuxtApp();
  return $api as ZirpApiClient;
};
